<template>
    <div class="profile_page">
        <div class="profile_header">
            <div class="profile_summary">
                <div class="profile_avatar">
                    <img src="../assets/logo.png" alt="avatar">
                </div>
                <div class="profile_main_info">
                    <div class="profile_name">喜乐司机</div>
                    <div class="profile_phone">{{mobile}}</div>
                </div>
            </div>
        </div>

        <div class="menu_list">
            <div class="menu_item">
                <span class="menu_label">头像</span>
                <div class="menu_value">
                    <img src="../assets/logo.png" alt="logo">
                </div>
            </div>
            <div class="menu_item">
                <span class="menu_label">手机号</span>
                <div class="menu_value">
                    <span>{{mobile}}</span>
                </div>
            </div>
        </div>

        <div class="logout_section">
            <div class="logout_btn" @click="exit">退出当前账号</div>
        </div>
        
        <tabbar :selected="selected"></tabbar>
    </div>
</template>

<script>
    import common from "../common";
    import tabbar from '@/components/tabbar'
    import {Indicator} from "mint-ui";

    export default {
        name: 'exit',
        components: {tabbar},
        data() {
            return {
                selected: "my",
                mobile: "",
                point: 0,
                token: ""
            }
        },
        methods: {
            goPay()
            {
                this.$router.push("/container-yard/pay");
            },
            exit() {
                common.deletelocalStorage("userInfo");
                common.clearCookie();
                this.$router.push("login");
            }
        },
        created() {
            //判断cookie中是否存在token
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
            } else if (ifcookietoken) {
                this.mobile = common.getCookie("mobile");
            } else {
                this.$router.replace({name: 'login'});
            }
        },
        mounted() {
            //判断cookie中是否存在token
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
            } else if (ifcookietoken) {
                this.token = common.getCookie("token");
            } else {
                this.$router.replace({name: 'login'});
            }
            this.getWallet();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .profile_page {
        width: 100vw;
        min-height: 100vh;
        background-color: #f6f8fa;
        display: flex;
        flex-direction: column;
        padding-bottom: 80px;
    }

    .profile_header {
        background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
        padding: 40px 20px 60px;
        display: flex;
        align-items: center;
    }

    .profile_summary {
        display: flex;
        align-items: center;
        gap: 20px;
    }

    .profile_avatar {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        border: 3px solid rgba(255, 255, 255, 0.3);
        overflow: hidden;
        background: white;
    }

    .profile_avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .profile_main_info {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .profile_name {
        font-size: 20px;
        font-weight: 700;
        color: white;
    }

    .profile_phone {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
    }

    .menu_list {
        margin: -30px 20px 0;
        background: white;
        border-radius: 16px;
        padding: 10px 0;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    }

    .menu_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid #f1f3f5;
    }

    .menu_item:last-child {
        border-bottom: none;
    }

    .menu_label {
        font-size: 15px;
        color: #495057;
        font-weight: 600;
    }

    .menu_value {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #adb5bd;
        font-size: 14px;
    }

    .menu_value img {
        width: 40px;
        height: 40px;
        border-radius: 8px;
    }

    .logout_section {
        padding: 40px 20px;
    }

    .logout_btn {
        width: 100%;
        height: 50px;
        background: white;
        border: 1px solid #ff6b6b;
        color: #ff6b6b;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 600;
        transition: all 0.2s;
    }

    .logout_btn:active {
        background: #fff5f5;
        transform: scale(0.98);
    }
</style>
      


// WEBPACK FOOTER //
// src/components/exit.vue